export type PriceRange = {
    fromPrice: number | null;
    toPrice: number | null;
};

const toPriceRange = (priceRange: string): PriceRange => {
    switch (priceRange) {
        case 'G':
            return { fromPrice: null, toPrice: 10 };
        case 'H':
            return { fromPrice: 10, toPrice: 25 };
        case 'I':
            return { fromPrice: 25, toPrice: 50 };
        case 'A':
            return { fromPrice: 50, toPrice: 100 };
        case 'B':
            return { fromPrice: 100, toPrice: 250 };
        case 'C':
            return { fromPrice: 250, toPrice: 500 };
        case 'D':
            return { fromPrice: 500, toPrice: 1000 };
        case 'E':
            return { fromPrice: 1000, toPrice: 5000 };
        case 'F':
            return { fromPrice: 5000, toPrice: null };
        default:
            return { fromPrice: null, toPrice: null };
    }
};

export const getPriceRange = (searchParams: {
    [key: string]: string;
}): PriceRange =>
    searchParams.priceRange
        ? toPriceRange(searchParams.priceRange)
        : {
              fromPrice: searchParams.fromPrice
                  ? parseInt(searchParams.fromPrice)
                  : null,
              toPrice: searchParams.toPrice
                  ? parseInt(searchParams.toPrice)
                  : null
          };
